import api from "./api";

const Denunciante ={
    async Comentario(state){
        await api.post(`denuncia`, state)
    }
}

export {Denunciante}